export const legalPersonsData = [
    {number: '01', title: 'Фізичні особи', text: 'Можливість опрацювання запитів у автоматичному та ручному режимі, за 14 напрямками'},
    {number: '02', title: 'Юридичні особи', text: 'Можливість опрацювання запитів у автоматичному та ручному режимі, за 15 напрямками'},
    {number: '03', title: 'Індивідуальні рішення', text: 'Можливість опрацювання індивідуальних запитів за 5 напрямками'}
]
